export default "__VITE_ASSET__DWO3q$Es__"